import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalDetailProdCondMagInv",
  ref: "modalDetailProdCondMagInvRef",
  role: "dialog",
  tabindex: "-1",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "tooltipmodal"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "table table-responsive-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, "Details de " + _toDisplayString($setup.product.nomProd.split("-")[0]), 1),
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.product.nomProd), 1),
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[1] || (_cache[1] = _createElementVNode("th", { class: "" }, "Quantité Logique", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.product.qteLogique), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("th", { class: "" }, "Quantité Fiche", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.product.qteFiche), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("th", { class: "" }, "Quantité Mag", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.product.qtePhysique), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("th", { class: "" }, "Ecart Fiche", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.product.ecartFiche), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("th", { class: "" }, "Ecart Logique", -1)),
                  _createElementVNode("td", null, _toDisplayString($setup.product.ecartLogique), 1)
                ])
              ])
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-footer" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            "data-bs-dismiss": "modal"
          }, "Fermer")
        ], -1))
      ])
    ])
  ], 512))
}